export default "__VITE_ASSET__CNb9WMMH__"